import {Component, OnInit, ViewChild} from '@angular/core';
import {UntilDestroy} from '@ngneat/until-destroy';
import {ModalComponent} from 'mbs-ui-kit';
import {NotificationServerSettingsService} from "@services";
import {I18NextPipe} from "angular-i18next";
import {BouncedEmail, BounceType} from "mbs-ui-shared@models/Notification";
import {tableHeaders} from "@components/unable-emails-modal/unable-emails-modal.constants";
import {finalize} from "rxjs/operators";
import {Router} from "@angular/router";
import {RoutingPath} from "mbs-ui-shared";

@UntilDestroy()
@Component({
  selector: 'mbs-unable-deliver-emails-modal',
  templateUrl: './unable-emails-modal.component.html'
})
export class UnableEmailsModalComponent implements OnInit {
  @ViewChild(ModalComponent, {static: true}) baseModal: ModalComponent;

  public loading = true
  public removeLoading = false

  public emails: Array<BouncedEmail>

  public readonly headers = tableHeaders(this.i18n);

  constructor(public serverSettingsService: NotificationServerSettingsService, private i18n: I18NextPipe, private router: Router) {
  }

  ngOnInit() {
    this.setBounseList()
  }

  public redirectToLogs(email: string) {
    const navigateToErrors = () => {
      this.router.navigate([RoutingPath.NotificationErrors], {
        queryParams: {
          search: `To Email: ${email}`
        }
      });
    }

    if (this.router.url.includes(RoutingPath.NotificationErrors)) {
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
        navigateToErrors()
      });
    } else {
      navigateToErrors()
    }

    this.baseModal.save()
  }

  public getReason(reason: BounceType): string {
    const texts = {
      [BounceType.PermanentBounce]: this.i18n.transform('shared:unable-emails-modal.labels.permanentBounce'),
      [BounceType.TransientBounce]: this.i18n.transform('shared:unable-emails-modal.labels.transientBounce'),
      [BounceType.Complaint]: this.i18n.transform('shared:unable-emails-modal.labels.complaint')
    }

    return this.i18n.transform('shared:unable-emails-modal.labels.emailRejected', {reason: texts[reason]})
  }

  public removeFromBounceList(email: string) {
    this.removeLoading = true
    this.serverSettingsService.removeFromBounceList(email).pipe(finalize(() => this.removeLoading = false)).subscribe(() => {
      this.setBounseList()
    })
  }

  private setBounseList() {
    this.loading = true
    this.serverSettingsService.getBounceList().pipe(finalize(() => this.loading = false)).subscribe(emails => {
      this.emails = emails.data
    })
  }
}
